<template>
    <div class="base">
        <!--<v-tabs v-model="tab" color="white" grow>-->
            <!--<v-tabs-slider color="primary"></v-tabs-slider>-->
            <!--<v-tab v-for="item in items" :to="{name: item.path}" :key="item.path">-->
                <!--<span class="primary&#45;&#45;text">{{ item.name }}</span>-->
            <!--</v-tab>-->
        <!--</v-tabs>-->
        <router-view></router-view>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                tab: 1,
                items: [
                    {name: '个人积分详情', path: 'myMission'},
                    {name: '任务列表', path: 'missionList'},
                    {name: '积分排行榜', path: 'rank'},
                ],
            }
        },
        mounted() {

        },
        computed: {},
        methods: {}
    }
</script>

<style lang="scss">

</style>
